
const HelpPage = () => {
  return (
    <div style={{ paddingBottom: '400px' }}>
      <br/>
      <p>
        If you have any questions or technical issues,
        you can send an email to
        &lt;<a href="mailto:admin@mathbombs.org">admin@mathbombs.org</a>&gt;.
      </p>
      <p>
        If you find any bugs or have any feature requests,
        you can create tickets for them
        on <a href="https://github.com/ironcamel/MathBombs/issues">github</a>.
      </p>
    </div>
  );
};

export default HelpPage;
